// WO-42: the server-rendered content of the first page load (lilycove-api services/seo.py), captured in index.js
// before React replaces #root. Pages that show server content (components/SeoExtras.js, pages/ServerPage.js) use it
// for the first render and fetch the same HTML from the api after client-side navigation, so people and crawlers
// always see the same text.

let captured = null;

export function captureSsr() {
  if (typeof document === 'undefined') return;
  const root = document.getElementById('root');
  const summary = root && root.querySelector('#lc-seo-summary');
  if (!summary) return;
  const extras = summary.querySelector('#lc-seo-extras');
  captured = {
    path: window.location.pathname,
    body: summary.innerHTML,
    extras: extras ? extras.outerHTML : '',
  };
}

export function ssrFor(path) {
  return captured && captured.path === path ? captured : null;
}

// Clicks on internal links inside server HTML navigate inside the SPA (no full reload).
export function spaLinkHandler(navigate) {
  return (e) => {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    const a = e.target.closest && e.target.closest('a[href]');
    const href = a && a.getAttribute('href');
    if (!href || !href.startsWith('/') || href.startsWith('//') || a.target) return;
    e.preventDefault();
    navigate(href);
  };
}
